import { render, staticRenderFns } from "./ScanTags.vue?vue&type=template&id=39f1e094&"
import script from "./ScanTags.vue?vue&type=script&lang=js&"
export * from "./ScanTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f1e094')) {
      api.createRecord('39f1e094', component.options)
    } else {
      api.reload('39f1e094', component.options)
    }
    module.hot.accept("./ScanTags.vue?vue&type=template&id=39f1e094&", function () {
      api.rerender('39f1e094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/createCode/ScanTags.vue"
export default component.exports